var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRequest = function SvgRequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89999 4.35002C2.89999 3.96546 3.05276 3.59665 3.32469 3.32472C3.59662 3.05279 3.96543 2.90002 4.34999 2.90002H7.47184C7.81507 2.90018 8.14711 3.02209 8.4089 3.24405C8.67069 3.46602 8.84525 3.77365 8.90154 4.11222L9.97454 10.543C10.0258 10.8492 9.97741 11.1639 9.83645 11.4406C9.69549 11.7173 9.46943 11.9414 9.19154 12.08L6.94694 13.2008C7.75185 15.1955 8.9506 17.0075 10.4716 18.5285C11.9925 20.0494 13.8045 21.2482 15.7992 22.0531L16.9215 19.8085C17.06 19.5309 17.2839 19.305 17.5603 19.164C17.8367 19.0231 18.151 18.9745 18.457 19.0255L24.8878 20.0985C25.2264 20.1548 25.534 20.3293 25.756 20.5911C25.9779 20.8529 26.0998 21.1849 26.1 21.5282V24.65C26.1 25.0346 25.9472 25.4034 25.6753 25.6753C25.4034 25.9473 25.0346 26.1 24.65 26.1H21.75C11.339 26.1 2.89999 17.661 2.89999 7.25002V4.35002Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/request.7ab5e3ae.svg";
export { ForwardRef as ReactComponent };